<template>
  <b-modal
    @show="onShow"
    no-fade
    size="lg"
    id="modal-permissions"
    no-close-on-esc
    no-close-on-backdrop
    :title="`Permissões do Usuário - ${user.name}`"
  >
    <b-tabs small active-nav-item-class="v-tab-active" v-model="tabIndex">
      <b-tab title="Páginas" active>
        <Tree :options="treeOptions" ref="permTree" />
      </b-tab>
      <b-tab title="UO">
        <b-table
          small
          hover
          bordered
          resposive
          striped
          head-variant="dark"
          selectable
          select-mode="single"
          selected-variant="primary"
          show-empty
          empty-text="Sem dados para exibir"
          :items="uoTable.data"
          :fields="uoTable.fields"
        >
          <template v-slot:cell(actions)="data">
            <b-button size="sm" variant="danger" @click="deleteUO(data.item)">
              <i class="fas fa-trash"></i>
            </b-button>
          </template>
        </b-table>
        <b-input-group class="mt-3">
          <v-select
            style="min-width:90%"
            id="uo_id"
            :options="combos.uo"
            label="descricao"
            :reduce="dep => dep.uo_id"
            :clearable="false"
            v-model="news.uo_id"
          >
            <template #no-options="{}">Sem dados a serem exibidos</template>
          </v-select>

          <b-input-group-append>
            <b-button @click="addUO()" size="sm" variant="info">
              <i class="fas fa-plus"></i>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-tab>
      <b-tab title="Departamentos">
        <b-table
          hover
          bordered
          resposive
          small
          striped
          head-variant="dark"
          selectable
          select-mode="single"
          selected-variant="primary"
          show-empty
          empty-text="Sem dados para exibir"
          :items="deptoTable.data"
          :fields="deptoTable.fields"
        ></b-table>
        <b-input-group class="mt-3">
          <v-select
            style="min-width:90%"
            id="departamento_id"
            :options="combos.depto"
            label="descricao"
            :reduce="dep => dep.departamento_id"
            :clearable="false"
            v-model="news.departamento_id"
          >
            <template #no-options="{}">Sem dados a serem exibidos</template>
          </v-select>
          <b-input-group-append>
            <b-button @click="addDepto()" size="sm" variant="info">
              <i class="fas fa-plus"></i>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-tab>
      <b-tab title="Unidades de Negócio">
        <b-table
          hover
          bordered
          resposive
          small
          striped
          head-variant="dark"
          selectable
          select-mode="single"
          selected-variant="primary"
          show-empty
          empty-text="Sem dados para exibir"
          :items="unTable.data"
          :fields="unTable.fields"
        >
          <template v-slot:cell(actions)="data">
            <b-button
              @click="deleteUN(data.item)"
            >
              <i class="fas fa-trash"></i>
            </b-button>
          </template>
        </b-table>
        <b-input-group class="mt-3">
          <v-select
            style="min-width:90%"
            id="unidade_id"
            :options="combos.un"
            label="descricao"
            :reduce="dep => dep.unidade_id"
            :clearable="false"
            v-model="news.unidade_id"
          >
            <template #option="{ unidade_id, descricao }">
              <span>{{ unidade_id }} - {{ descricao }}</span>
            </template>
            <template #selected-option="{ unidade_id, descricao }">
              <span>{{ unidade_id }} - {{ descricao }}</span>
            </template>
            <template #no-options="{}">Sem dados a serem exibidos</template>
          </v-select>

          <b-input-group-append>
            <b-button @click="addUN()" size="sm" variant="info">
              <i class="fas fa-plus"></i>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-tab>
    </b-tabs>
    <template v-slot:modal-footer>
      <b-button v-show="tabIndex === 0" size="sm" @click="savePages()" variant="primary">
        <i class="fas fa-check"></i> Gravar
      </b-button>
      <b-button size="sm" @click="() => $bvModal.hide('modal-permissions')">Cancelar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Tree from "liquor-tree";

export default {
  name: "ModalPermissions",
  components: { Tree },
  props: ["user"],
  data: function() {
    return {
      tabIndex: 0,
      menus: [],
      deptoTable: {
        data: [],
        fields: [
          { key: "departamento_id", label: "Código" },
          { key: "descricao", label: "Descrição" },
          { key: "actions", label: "Ações" }
        ]
      },
      uoTable: {
        data: [],
        fields: [
          { key: "uo_id", label: "Código" },
          { key: "descricao", label: "Descrição" },
          { key: "actions", label: "Ações" }
        ]
      },
      unTable: {
        data: [],
        fields: [
          { key: "unidade_id", label: "Código" },
          { key: "descricao", label: "Descrição" },
          { key: "actions", label: "Ações" }
        ]
      },
      treeOptions: {
        checkbox: true,
        propertyNames: { text: "pagina_label", data: "customData" }
      },
      combos: {
        uo: [],
        depto: [],
        un: []
      },
      news: {
        departamento_id: "",
        uo_id: "",
        unidade_id: ""
      }
    };
  },
  methods: {
    onShow() {
      this.getMenus();
      this.getUOS();
      this.getDeps();
      this.getUN();
      this.loadCombos();
    },
    getMenus() {
      axios
        .get(`${baseApiUrl}/menu`)
        .then(resp => {
          for (const iterator of resp.data) {
            iterator.customData = iterator;
          }
          this.$refs.permTree.tree.setModel(this.toTree(resp.data));
        })
        .catch(ex => showError(ex));
    },
    getUOS() {
      this.uoTable.data = []
      axios
        .get(`${baseApiUrl}/usuarios/${this.user.email}/uo`)
        .then(resp => (this.uoTable.data = resp.data))
        .catch(ex => showError(ex));
    },
    getDeps() {
      this.deptoTable.data = []
      axios
        .get(`${baseApiUrl}/usuarios/${this.user.email}/depto`)
        .then(resp => (this.deptoTable.data = resp.data))
        .catch(ex => showError(ex));
    },
    getUN() {
      this.unTable.data = []
      axios
        .get(`${baseApiUrl}/usuarios/${this.user.email}/un`)
        .then(resp => (this.unTable.data = resp.data))
        .catch(ex => showError(ex));
    },
    toTree(categories, tree) {
      if (!tree) tree = categories.filter(c => !c.menu_id_pai);

      tree = tree.map(parentNode => {
        const isChild = node => node.menu_id_pai == parentNode.menu_id;
        parentNode.children = this.toTree(
          categories,
          categories.filter(isChild)
        );
        return parentNode;
      });
      return tree;
    },
    loadCombos() {
      axios
        .get(`${baseApiUrl}/uo`)
        .then(resp => (this.combos.uo = resp.data))
        .catch(ex => showError(ex));

      axios
        .get(`${baseApiUrl}/departamentos`)
        .then(resp => (this.combos.depto = resp.data))
        .catch(ex => showError(ex));

      axios
        .get(`${baseApiUrl}/unidadesnegocio`)
        .then(resp => (this.combos.un = resp.data))
        .catch(ex => showError(ex));
    },
    addUO() {
      if (this.news.uo_id === "") return;
      axios
        .post(`${baseApiUrl}/usuarios/uo`, {
          usuario_id: this.user.email,
          uo_id: this.news.uo_id
        })
        .then(() => this.getUOS());
    },
    addDepto() {
      if (this.news.departamento_id === "") return;
      axios
        .post(`${baseApiUrl}/usuarios/depto`, {
          usuario_id: this.user.email,
          departamento_id: this.news.departamento_id
        })
        .then(() => this.getDeps());
    },
    addUN() {
      if (this.news.unidade_id === "") return;
      axios
        .post(`${baseApiUrl}/usuarios/un`, {
          usuario_id: this.user.email,
          unidade_id: this.news.unidade_id
        })
        .then(() => this.getUN());
    },
    deleteUO() {
      if (this.news.uo_id === "") return;
      axios
        .delete(`${baseApiUrl}/usuarios/perm/uo`, {
          usuario_id: this.user.email,
          uo_id: this.news.uo_id
        })
        .then(() => this.getUOS());
    },
    deleteDepto() {
      if (this.news.departamento_id === "") return;
      axios
        .delete(`${baseApiUrl}/usuarios/perm/depto`, {
          usuario_id: this.user.email,
          departamento_id: this.news.departamento_id
        })
        .then(() => this.getDeps());
    },
    deleteUN(unidade) {
      axios
        .delete(`${baseApiUrl}/usuarios/perm/un`, {
          data: {usuario_id: this.user.email,
          unidade_id: unidade.unidade_id}
        })
        .then(() => this.getUN());
    },
    savePages() {
      let nodes = this.$refs.permTree.findAll({ state: { checked: true } });
      let paginas = [];

      if (nodes.length > 0) {
        for (const iterator of nodes) {
          paginas.push({ menu_id: iterator.data.menu_id, ind_permite: true });
        }
      }

      nodes = this.$refs.permTree.findAll({ state: { indeterminate: true } });
      if (nodes.length > 0) {
        for (const iterator of nodes) {
          paginas.push({ menu_id: iterator.data.menu_id, ind_permite: true });
        }
      }

      if (paginas.length > 0) {
        axios
          .post(`${baseApiUrl}/usuarios/permissoes`, {
            usuario_id: this.user.email,
            paginas: paginas
          })
          .then(() =>
            this.$toasted.info("Permissões aplicadas!", {
              duration: 4000,
              keepOnHover: true
            })
          )
          .catch(ex => showError(ex));
      }
    }
  },
  mounted() {}
};
</script>

<style>
</style>